module.exports = __webpack_public_path__ + "static/media/loop_24dp.799b56d4.svg";